import type { Course } from "@repo/app-types/entities/course";

export function mapSectionClientIdsToServerIds(
  course: Course,
  savedSections: Record<string, { id: string } | undefined>,
): Course {
  return {
    ...course,
    chapters: course.chapters.map((chapter) => ({
      ...chapter,
      lessons: chapter.lessons.map((lesson) => {
        const savedSection = savedSections[lesson.interviewSectionDefinitionId];
        return savedSection
          ? { interviewSectionDefinitionId: savedSection.id }
          : lesson;
      }),
    })),
  };
}
